/*
This file is located in the main branch
Last time the file was updated (UTC): [11/6/2024 4:35:58AM]
Permissions to update outside the main branch: [false]
*/

import { getMonth, getYear } from 'date-fns';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import { range } from 'lodash';
import { useMemo } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
import './DatePickerHeader.nova.scss';
import { toInt } from '@finbeat/react-toolkit';

const DatePickerHeaderNova = ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
}: ReactDatePickerCustomHeaderProps): JSX.Element => {
    const { i18n } = useTranslation();
    const years = range(1900, getYear(new Date()) + 100, 1);

    const months = useMemo(() => {
        return [...Array(12).keys()].map((x) =>
            new Intl.DateTimeFormat(i18n.language, { month: 'long' }).format(new Date(2000, x, 1))
        );
    }, [i18n]);

    return (
        <div className="date-picker-header">
            <div>
                <select
                    className="custom-scrollbar"
                    value={months[getMonth(date)]}
                    onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
                >
                    {months.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>
                <select
                    className="custom-scrollbar"
                    value={getYear(date)}
                    onChange={({ target: { value } }) => changeYear(toInt(value) ?? 0)}
                >
                    {years.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>
            </div>

            <div>
                <button type="button" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                    <IoIosArrowBack />
                </button>

                <button type="button" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                    <IoIosArrowForward />
                </button>
            </div>
        </div>
    );
};

export default DatePickerHeaderNova;
